import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChartsModule } from 'ng2-charts';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { PaginatePipe } from './pipes/paginate/paginate.pipe';

@NgModule({
	declarations: [
		PaginatePipe
	],
	imports: [
		ReactiveFormsModule,
		FormsModule,
		MatTooltipModule,
		MatInputModule,
		MatSelectModule,
		ChartsModule,
		MatExpansionModule,
		MatIconModule,
		TranslateModule.forChild(),
	],
	exports: [
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		MatInputModule,
		MatTooltipModule,
		MatSelectModule,
		ChartsModule,
		MatExpansionModule,
		PaginatePipe
	],
	providers: [DatePipe],
})
export class SharedModule {}
